
document.addEventListener('DOMContentLoaded', function() {

  // İlk kurulumları yap
  setupVariantLabels();
  checkDisabledVariants(); // Bu fonksiyon içinde setupDropdownItemClicks() çağrılıyor
  highlightSelectedDropdownItems();

  // Sayfa yüklendiğinde mevcut seçili input'ların label'larını güncelle
  document.querySelectorAll('.variant-input-wrap input[type="radio"]:checked').forEach(input => {
    updateSelectedLabelText(input);
  });

  // Shopify varyant değişikliklerini dinle
  document.addEventListener('variant:change', function() {
    setTimeout(() => {
      setupVariantLabels();
      checkDisabledVariants();
      highlightSelectedDropdownItems();
    }, 100);
  });

  // Sayfa içi AJAX yüklemelerini dinle
  document.addEventListener('page:loaded', function() {
    setTimeout(() => {
      setupVariantLabels();
      checkDisabledVariants();
      highlightSelectedDropdownItems();
    }, 100);
  });

  // Sayfa tamamen yüklendikten sonra birkaç kez daha kontrol et
  // Bazen dinamik yüklenen içerik olabilir
  let checkCount = 0;
  const intervalCheck = setInterval(function() {
    checkCount++;
    setupVariantLabels();
    checkDisabledVariants();
    highlightSelectedDropdownItems();
    if (checkCount >= 5) clearInterval(intervalCheck);
  }, 1000);

  // Radio buton değişikliklerini dinle
  document.addEventListener('change', function(e) {
    if (e.target && e.target.matches('input[type="radio"][data-variant-input]')) {
      // Radio input değişikliklerinde label değerlerini güncelle
      updateSelectedLabelText(e.target);

      setTimeout(() => {
        checkDisabledVariants();
        highlightSelectedDropdownItems();
      }, 100);
    }
  });

  // Dropdown click olayları için doğrudan dinleyici ekle
  document.addEventListener('click', function(e) {
    // Tıklanan öğe veya üst öğesi dropdown-item ise
    const dropdownItem = e.target.closest('.dropdown-item');
    if (dropdownItem) {

      if (!dropdownItem.classList.contains('dropdown-item--sold-out') &&
          dropdownItem.getAttribute('data-available') !== 'false') {

        const optionIndex = dropdownItem.getAttribute('data-index');
        const optionValue = dropdownItem.getAttribute('data-value');

        // Dropdown trigger içeriğini güncelle
        try {
          const customDropdown = dropdownItem.closest('.custom-dropdown');
          if (customDropdown) {
            const dropdownTrigger = customDropdown.querySelector('.custom-dropdown__trigger .custom-dropdown__inside');
            if (dropdownTrigger) {
              // Resim içeren item için resmi kopyalayalım
              const itemImage = dropdownItem.querySelector('img');
              const triggerImage = dropdownTrigger.querySelector('img');

              if (itemImage && triggerImage) {
                triggerImage.src = itemImage.src;
                triggerImage.alt = itemImage.alt;
              }

              // Text içeriğini de güncelleyelim
              const itemText = dropdownItem.textContent.trim().replace('Sold Out', '').trim();

              // HTML içeriğini koruyarak sadece text kısmını değiştir
              const imgHtml = triggerImage ? triggerImage.outerHTML : '';
              dropdownTrigger.innerHTML = imgHtml + ' ' + itemText;
            }
          }
        } catch (dropdownError) {
          console.warn('Dropdown güncellenirken hata:', dropdownError);
        }

        if (optionIndex && optionValue) {

          const matchingInput = document.querySelector(
            `input[type="radio"][data-index="${optionIndex}"][value="${optionValue}"]`
          );

          if (matchingInput && !matchingInput.disabled) {

            // Aynı gruptaki diğer radio butonlarının seçimini kaldır
            const optionName = matchingInput.getAttribute('name');
            if (optionName) {
              document.querySelectorAll(`input[type="radio"][name="${optionName}"]`).forEach(radio => {
                radio.removeAttribute('checked');
                radio.checked = false;
              });
            }

            // Bu radio butonu seç
            matchingInput.checked = true;
            matchingInput.setAttribute('checked', 'checked');

            // Seçili varyant label textini güncelle
            updateSelectedLabelText(matchingInput);

            // Change olayını tetikle
            matchingInput.dispatchEvent(new Event('change', { bubbles: true }));

            // Dropdown menüyü kapat (isteğe bağlı)
            const customDropdown = dropdownItem.closest('.custom-dropdown');
            if (customDropdown) {
              setTimeout(() => {
                // Menüyü kapatmak için başka bir yere tıklamış gibi yapalım
                document.body.click();
              }, 150);
            }
          }
        }
      }
    }
  });
});


function setupVariantLabels() {
  document.querySelectorAll('input[type="radio"]:checked').forEach(radio => {
    radio.setAttribute('checked', 'checked');
  });

  const variantInputs = document.querySelectorAll('.variant-input');

  variantInputs.forEach(variantInput => {

    const label = variantInput.querySelector('label.variant__button-label');


    if (label && !label.hasAttribute('data-event-added')) {

      const input = variantInput.querySelector('input[type="radio"]');

      if (input) {

        label.addEventListener('click', function(e) {

          if (input.hasAttribute('disabled') || input.classList.contains('disabled')) {
            return;
          }

          const optionName = input.getAttribute('name');
          if (optionName) {
            document.querySelectorAll(`input[type="radio"][name="${optionName}"]`).forEach(radio => {
              radio.removeAttribute('checked');
              radio.checked = false;
            });
          }

          input.setAttribute('checked', 'checked');
          input.checked = true;

          // Seçili varyant label textini güncelle
          updateSelectedLabelText(input);

          const changeEvent = new Event('change', { bubbles: true });
          input.dispatchEvent(changeEvent);

          updateVariantSelection(input);
        });


        label.setAttribute('data-event-added', 'true');
      }
    }
  });
}


function updateVariantSelection(selectedInput) {

  if (selectedInput) {
    const optionIndex = selectedInput.getAttribute('data-index');
    const optionValue = selectedInput.value;

    // Label text güncelleme işini updateSelectedLabelText fonksiyonuna devrettik
    // Bu çağrıyı koruyoruz, ancak asıl işi artık updateSelectedLabelText yapıyor
    updateSelectedLabelText(selectedInput);



    try {
      // Tüm dropdown öğelerini al
      const allDropdownItems = document.querySelectorAll('.dropdown-item');

      // Aynı option index'e sahip tüm dropdown öğelerinden box shadow'u kaldır
      allDropdownItems.forEach(item => {
        if (item.getAttribute('data-index') === optionIndex) {
          item.style.boxShadow = 'none';
        }
      });

      // Seçilen option ve value değerine sahip olan dropdown öğesine box shadow ekle
      allDropdownItems.forEach(item => {
        const itemIndex = item.getAttribute('data-index');
        const itemValue = item.getAttribute('data-value');

        if (itemIndex === optionIndex &&
            itemValue === optionValue &&
            !item.classList.contains('dropdown-item--sold-out')) {
          item.style.boxShadow = '0 0 0 2px var(--colorTextBody)';
        }
      });
    } catch (error) {
      console.error("Varyant seçim hatası:", error);
    }

    setTimeout(checkDisabledVariants, 100);
  }
}


/**
 * Dropdown Item tıklama olaylarını ayarlayan fonksiyon
 */
function setupDropdownItemClicks() {
  // Tüm dropdown-item'lara tıklama olayları ekle (daha önce eklenmiş olsalar bile)
  document.querySelectorAll('.dropdown-item').forEach(item => {
    // Önce mevcut tıklama olaylarını temizle
    const clone = item.cloneNode(true);
    if (item.parentNode) {
      item.parentNode.replaceChild(clone, item);
      item = clone; // Bundan sonra yeni klonlanmış öğeyle çalış
    }

    if (item.classList.contains('dropdown-item--sold-out') || item.getAttribute('data-available') === 'false') {
      // Sold out olan item'lara tıklamayı engelle
      item.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }, true);
    } else {
      // Normal dropdown item'lara tıklama olayı ekle
      item.addEventListener('click', function(e) {
        const optionIndex = item.getAttribute('data-index');
        const optionValue = item.getAttribute('data-value');

        if (!optionIndex || !optionValue) {
          console.error('Dropdown item üzerinde veri eksik:', item);
          return;
        }

        // Aynı grupdaki tüm dropdown-item'ların box-shadow'unu temizle
        Array.from(document.querySelectorAll('.dropdown-item'))
          .filter(dropdownItem => dropdownItem.getAttribute('data-index') === optionIndex)
          .forEach(dropdownItem => {
            dropdownItem.style.boxShadow = 'none';
          });

        // Bu item'a box-shadow ekle
        item.style.boxShadow = '0 0 0 2px var(--colorTextBody)';

        try {
          // Eşleşen radio butonunu bul ve seç
          const matchingInputSelector = `input[type="radio"][data-index="${optionIndex}"][value="${optionValue}"]`;
          const matchingInput = document.querySelector(matchingInputSelector);

          if (matchingInput && !matchingInput.disabled && !matchingInput.classList.contains('disabled')) {

            // Aynı gruptan diğer radyoların seçimini kaldır
            const optionName = matchingInput.getAttribute('name');
            if (optionName) {
              document.querySelectorAll(`input[type="radio"][name="${optionName}"]`).forEach(radio => {
                radio.removeAttribute('checked');
                radio.checked = false;
              });
            }

            // Bu radyoyu seç
            matchingInput.setAttribute('checked', 'checked');
            matchingInput.checked = true;


            // Change olayını tetikle
            const changeEvent = new Event('change', { bubbles: true });
            matchingInput.dispatchEvent(changeEvent);

          } else {
            console.warn('Uygun radio bulunamadı veya disabled durumda');
          }
        } catch (error) {
          console.error('Radio seçme hatası:', error);
        }
      });
    }

    // Tıklama olayı eklendiğini işaretle
    item.setAttribute('data-click-added', 'true');
  });
}

/**
 * Seçili olan dropdown-item'ları vurgulayan fonksiyon
 */
function highlightSelectedDropdownItems() {
  // Seçili inputları bul
  const checkedInputs = document.querySelectorAll('.variant-input-wrap input[type="radio"]:checked');

  // Her seçili input için
  checkedInputs.forEach(input => {
    const optionIndex = input.getAttribute('data-index');
    const optionValue = input.value;

    // Seçili dropdown-item'ları bul
    Array.from(document.querySelectorAll('.dropdown-item'))
      .filter(item => item.getAttribute('data-index') === optionIndex)
      .forEach(item => {
        // Önce tüm box-shadow'ları temizle
        item.style.boxShadow = 'none';
      });

    // Eşleşen dropdown-item'a box-shadow ekle
    Array.from(document.querySelectorAll('.dropdown-item'))
      .filter(item =>
        item.getAttribute('data-index') === optionIndex &&
        item.getAttribute('data-value') === optionValue)
      .forEach(item => {
        if (!item.classList.contains('dropdown-item--sold-out') && item.getAttribute('data-available') !== 'false') {
          item.style.boxShadow = '0 0 0 2px var(--colorTextBody)';
        }
      });
  });
}

/**
 * Seçili input'un value değerini ilgili variant__label--selected span'ine ekler
 * Farklı varyant türleri (örn: Size, Color) için özel label span'lerini günceller
 * @param {HTMLInputElement} selectedInput - Seçili input elementi
 */
function updateSelectedLabelText(selectedInput) {
  if (!selectedInput) return;

  try {
    // Varyant option index'ini al (option0, option1, option2 gibi)
    const optionIndex = selectedInput.getAttribute('data-index');
    if (!optionIndex) return;

    // Input değerini al
    const optionValue = selectedInput.value;
    if (!optionValue) return;

    // Numerik indeksi al (örn: option1 -> 1)
    const numericIndex = optionIndex.replace('option', '');

    // Input'un ait olduğu variant-input-wrap'i bulalım
    const variantInputWrap = selectedInput.closest('.variant-input-wrap');
    if (!variantInputWrap) {
      console.warn('Varyant input wrap bulunamadı:', selectedInput);
      return;
    }

    // Input'un ait olduğu varyant ismini bulalım
    const inputName = selectedInput.getAttribute('name');
    const variantName = variantInputWrap.getAttribute('name');
    console.log(`Güncelleniyor: ${variantName} varyantı için ${optionValue} değeri`);

    // Bu varyant grubuna ait variant-wrapper'ı bulalım
    const variantWrapper = variantInputWrap.closest('.variant-wrapper');
    if (!variantWrapper) {
      console.warn('Varyant wrapper bulunamadı:', selectedInput);
      return;
    }

    // Bu varyant wrapper içindeki label span'ini bulalım
    const selectedLabel = variantWrapper.querySelector('.variant__label--selected[data-variant-selected-label]');
    if (selectedLabel) {
      // Doğru span'i bulduk ve güncelliyoruz
      selectedLabel.textContent = optionValue;
      console.log(`"${variantName}" varyant etiketi güncellendi: "${optionValue}"`);

      // Özel variant-wrapper yapısı için dropdown içeriğini de güncelle
      try {
        // Varyant ismini al
        const optionName = variantWrapper.querySelector('.variant__label')?.textContent?.trim().replace(':', '') || '';

        if (optionName) {
          // Aynı option name'e sahip custom dropdown'ı bul
          const customDropdown = document.querySelector(`.custom-dropdown[data-option-name="${optionName.toLowerCase()}"]`);
          if (customDropdown) {
            console.log(`"${optionName}" için custom dropdown bulundu ve güncelleniyor...`);
            const dropdownTrigger = customDropdown.querySelector('.custom-dropdown__trigger .custom-dropdown__inside');
            if (dropdownTrigger) {
              // Text içeriğini güncelle ama img elementi varsa koru
              const imgElement = dropdownTrigger.querySelector('img');
              if (imgElement) {
                // Resim dosyasını da güncellemek gerekebilir
                const newImageName = optionValue.toLowerCase().replace(/\s+/g, '-');
                const currentSrc = imgElement.getAttribute('src');
                const fileExtension = currentSrc.split('.').pop();

                // Sadece dosya adını değiştir, path'i koru
                const basePath = currentSrc.substring(0, currentSrc.lastIndexOf('/') + 1);
                const newSrc = `${basePath}${newImageName}.${fileExtension}`;

                // Sadece eğer dosya adı değiştiyse güncelle
                if (currentSrc !== newSrc && !currentSrc.includes('no-image')) {
                  imgElement.setAttribute('src', newSrc);
                  imgElement.setAttribute('alt', optionValue);
                  console.log(`Dropdown resmi güncellendi: ${newSrc}`);
                }

                // Text içeriğini değiştir - imgElement sonrasındaki text'i güncelle
                // Önce tüm metin içeriğini temizle
                Array.from(dropdownTrigger.childNodes)
                  .filter(node => node.nodeType === Node.TEXT_NODE)
                  .forEach(node => node.parentNode.removeChild(node));

                // Sonra yeni metin ekle
                dropdownTrigger.appendChild(document.createTextNode(' ' + optionValue));
                console.log(`Dropdown metni güncellendi: "${optionValue}"`);
              } else {
                // Resim yoksa sadece metni güncelle
                dropdownTrigger.textContent = optionValue;
              }
            }
          } else {
            console.log(`"${optionName}" için custom dropdown bulunamadı.`);
          }
        }
      } catch (dropdownError) {
        console.warn('Dropdown güncelleme hatası:', dropdownError);
      }
    } else {
      // Geriye dönük uyumluluk için eski yöntemi de kullanalım
      // Eğer variantWrapper içinde seçili label bulamadıysak, global olarak arayalım
      console.log('Varyant içinde label bulunamadı, genel arama yapılıyor...');
      const allSelectedLabels = document.querySelectorAll(`.variant__label--selected[data-variant-selected-label][data-index="${numericIndex}"]`);

      allSelectedLabels.forEach(label => {
        label.textContent = optionValue;
        console.log(`Genel arama ile etiket güncellendi: ${numericIndex} indeksi için "${optionValue}"`);
      });
    }

    console.log(`Varyant seçimi tamamlandı: ${variantName || 'Bilinmeyen varyant'} = "${optionValue}"`);
  } catch (error) {
    console.error('Label güncelleme hatası:', error);
  }
}

/**
 * Disabled varyantları kontrol eden ve ilgili dropdown-item'ları güncelleyen fonksiyon
 * Hem varyant input'larda hem de dropdown öğelerinde sold-out durumunu işler
 */
function checkDisabledVariants() {
  try {
    // Önce tüm dropdown-item'ları kullanılabilir olarak işaretle ve data-click-added özelliğini kaldır
    document.querySelectorAll('.dropdown-item').forEach(item => {
      // Sold out sınıfını temizle
      if(item.classList.contains('dropdown-item--sold-out')) {
        item.classList.remove('dropdown-item--sold-out');
      }

      // Kullanılabilir olarak işaretle
      item.setAttribute('data-available', 'true');

      // Tıklama olayının yeniden eklenmesi için data-click-added özelliğini sil
      item.removeAttribute('data-click-added');
    });

    // Her bir varyant grubu için mevcut seçimlere göre mevcut olmayan kombinasyonları denetleme
    const currentSelections = {};

    // Seçili varyantları topla
    document.querySelectorAll('.variant-input-wrap input[type="radio"]:checked').forEach(input => {
      const optionIndex = input.getAttribute('data-index');
      if (optionIndex) {
        currentSelections[optionIndex] = input.value;
      }
    });

    // Disabled inputları bul - Hem disabled="true" hem de disabled attribute'üne sahip olanlar
    const disabledInputs = document.querySelectorAll('.variant-input-wrap input[disabled="true"], .variant-input-wrap input[disabled], .variant-input-wrap input.disabled');

    // Eşleşen dropdown-item'ları işaretle
    disabledInputs.forEach(input => {
      const inputValue = input.value;
      const inputIndex = input.getAttribute('data-index');

      // İndeks spesifik dropdown öğelerini bul - Varsa indeks belirtilen öğelerde ara
      let matchingDropdownItems;
      if (inputIndex) {
        // CSS seçicisinde özel karakterler olabilecek değerleri güvenli bir şekilde kullan
        // getAttribute ile karşılaştırma yaparak özel karakterlerden kaçınalım
        matchingDropdownItems = Array.from(document.querySelectorAll(`.dropdown-item[data-index="${inputIndex}"]`))
          .filter(item => item.getAttribute('data-value') === inputValue);
      } else {
        // İndeks belirtilmemişse, tüm dropdown item'ları içinde değere göre filtreleme yapalım
        matchingDropdownItems = Array.from(document.querySelectorAll('.dropdown-item'))
          .filter(item => item.getAttribute('data-value') === inputValue);
      }

      matchingDropdownItems.forEach(item => {
        if (!item.classList.contains('dropdown-item--sold-out')) {
          item.classList.add('dropdown-item--sold-out');
        }

        item.setAttribute('data-available', 'false');

        // CSS ile kontrol edildiği için sold-out badge eklemeye gerek yok
        // Eğer custom-dropdown.liquid'de zaten badge eklenmiyorsa, siz ekleyebilirsiniz
        /*
        if (!item.querySelector('.sold-out-badge')) {
          const soldOutBadge = document.createElement('span');
          soldOutBadge.classList.add('sold-out-badge');
          soldOutBadge.textContent = 'Sold Out';
          item.appendChild(soldOutBadge);
        }
        */
      });
    });

    // Ek olarak, Shopify'ın disabled sınıfını kullanan varyant etiketlerini de işleyelim
    document.querySelectorAll('label.variant__button-label.disabled').forEach(label => {
      // Eşleşen dropdown öğesini bul ve işaretle
      const inputId = label.getAttribute('for');
      if (inputId) {
        const input = document.getElementById(inputId);
        if (input) {
          const inputValue = input.value;
          // Özel karakterler içerebilen değerleri güvenli bir şekilde ele al
          Array.from(document.querySelectorAll('.dropdown-item'))
            .filter(item => item.getAttribute('data-value') === inputValue)
            .forEach(item => {
              if (!item.classList.contains('dropdown-item--sold-out')) {
                item.classList.add('dropdown-item--sold-out');
              }
              item.setAttribute('data-available', 'false');
            });
        }
      }
    });

    // Tüm dropdown-item'lara tıklama olaylarını yeniden ekleyelim
    document.querySelectorAll('.dropdown-item').forEach(item => {
      // Önce mevcut tüm click event listener'ları temizle
      const newItem = item.cloneNode(true);
      if(item.parentNode) {
        item.parentNode.replaceChild(newItem, item);
      }
    });

    // Tüm dropdown-item tıklama olaylarını yeniden kuruyoruz
    setupDropdownItemClicks();

    // Varyant seçimi değiştikten sonra, seçili dropdown öğelerini vurgula
    highlightSelectedDropdownItems();

    console.log('Disabled variants updated successfully.');
  } catch (error) {
    console.error("Disabled variants issue:", error);
  }
}
